import React from 'react';
import AdminManagementPage from '../components/admin/AdminManagementPage/AdminManagementPage';
import AppSidebar from '../components/AppSidebar/AppSidebar';

export default function AdminManagementLayout() {
  return (
    <AppSidebar>
      <AdminManagementPage />
    </AppSidebar>
  );
}
